module.exports = __webpack_public_path__ + "assets/img/register_date-4d6a7008.png";